<template>
  <div
    class="t-skeleton"
    :class="[{
      't-skeleton--circle': circle,
      't-skeleton--pulsing': pulsing,
    }]"
    :style="{
      width: width,
      height: height,
    }"
  ></div>
</template>

<script>
export default {
  name: 't-skeleton',
  props: {
    circle: Boolean,
    pulsing: Boolean,
    width: String,
    height: String,
  },
};
</script>
